export default "dist/images/components-columns-width-control-4-3.5c76fd1.png";